import "@/styles/globals.css";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { AppThemeProvider } from "@/contexts/theme";
import { onPersistError, onPersistRestored, persistOptions, queryClient } from "@/lib/api";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    {/* PersistQueryClientProvider, not QueryClientProvider: it hydrates the
        cache from sessionStorage before the first render and keeps writing to
        it as queries settle, so a hard refresh repaints from the previous
        page's data instead of a full set of skeletons. What is allowed into
        storage — and what never is — lives in `lib/api/persist.ts`. */}
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={persistOptions}
      onSuccess={onPersistRestored}
      onError={onPersistError}
    >
      {/* AppThemeProvider decides light vs dark (OS preference until someone
          picks) and renders the DS ThemeProvider itself. */}
      <AppThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  </StrictMode>,
);
